var $52537a7562a0fcd4$exports = {};
$52537a7562a0fcd4$exports = {
    "loading": `Laadimine...`,
    "placeholder": `Valige\u{2026}`
};


export {$52537a7562a0fcd4$exports as default};
//# sourceMappingURL=et-EE.module.js.map
